import { useCallback, useState } from "react";

import { errorToast, successToast } from "src/shared/components";

import {
  printHardwarePackage,
  PrintHardwarePackagePayload,
} from "./printHardwareLabel";

export const usePrintHardwareLabel = () => {
  const [printingRequestId, setPrintingRequestId] = useState<number | null>(
    null
  );

  const printLabel = useCallback(
    async (requestId: number, payload: PrintHardwarePackagePayload) => {
      setPrintingRequestId(requestId);
      try {
        await printHardwarePackage(payload);
        successToast("Label sent to printer successfully!");
      } catch (e) {
        errorToast(
          (e as Error)?.message ||
            "Failed to connect to printer. Please check the endpoint URL."
        );
      } finally {
        setPrintingRequestId(null);
      }
    },
    []
  );

  return { printingRequestId, printLabel };
};
